<template>
  <div class="search-bar">
    <label-input
      class="label-input"
      width="368px"
      label="药品通用名"
      type="autocomplete"
      v-model="name"
      :query-search="querySearch"
      :input-attr="{ clearable: true }"
    />
    <label-input
      class="label-input"
      width="368px"
      v-model="barcode"
      label="药品条形码"
      :input-attr="{ maxLength: 20, clearable: true }"
    />
    <label-input
      class="label-input"
      width="368px"
      v-model="medicalInsuranceCode"
      label="医保药品代码"
      :input-attr="{ clearable: true }"
    />

    <el-button class="el-button--primary is-plain btn" @click="$emit('search')">搜索</el-button>
    <el-button class="el-button--default is-plain btn" @click="$emit('reset')">重置</el-button>
  </div>
</template>

<script>
import labelInput from '@/components/global/form/labelInput';
import Fetch from '@/api';

export default {
  name: 'searchBar',
  components: {
    labelInput
  },
  props: {
    searchParams: {
      type: Object
    }
  },
  computed: {
    name: {
      get() {
        return this.searchParams.drugName;
      },
      set(val) {
        this.$emit('change', 'drugName', val);
      }
    },
    barcode: {
      get() {
        return this.searchParams.barcode;
      },
      set(val) {
        this.$emit('change', 'barcode', val);
      }
    },
    medicalInsuranceCode: {
      get() {
        return this.searchParams.medicalInsuranceCode;
      },
      set(val) {
        this.$emit('change', 'medicalInsuranceCode', val);
      }
    }
  },
  methods: {
    querySearch(queryString, cb) {
      if (queryString.length > 1) {
        return Fetch.query_gnu_by_name({ name: queryString }).then(data => {
          if (data) {
            cb(data);
          } else {
            cb([]);
          }
        });
      } else {
        cb([]);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-bar {
  display: flex;
  margin-bottom: 24px;

  .label-input {
    margin-right: 16px;
  }

  .btn {
    width: 80px;
  }
}
</style>
